/** "Alena Vzorová" for "Ing. Alena Vzorová" – titles (Ing., MUDr.) end with a dot. */
export const withoutTitles = (name: string) =>
	name
		.split(' ')
		.filter(part => part && !part.endsWith('.'))
		.join(' ');
